import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ProblemCreateUpdate from "./create-update";
import { ProblemItem } from "../../../models/types/problem";
import problemSvc from "../../../services/api/problem";
import Loading from "../../../components/loading/loading";

export default function ProblemCreateUpdatePage() {
    const { id } = useParams<{ id?: string }>();

    const isCreate = !id;
    const [data, setData] = useState<ProblemItem | null>(null);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (id) {
            setLoading(true);
            problemSvc.getProblemById(id).then((res) => {
                setData(res.content);
            }).finally(() => {
                setLoading(false);
            });
        }
    }, [id]);
    return (
        <div className="page-wrapper h-full">
            {loading ? <Loading /> : <ProblemCreateUpdate isCreate={isCreate} data={data} />}
        </div>
    );
}